import { render } from "./auth-login.vue?vue&type=template&id=b2af7a72"
import script from "./auth-login.vue?vue&type=script&lang=js"
export * from "./auth-login.vue?vue&type=script&lang=js"

import "./auth-login.vue?vue&type=style&index=0&id=b2af7a72&lang=css"

import exportComponent from "C:\\active-project\\NeginPostClub\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__